import {
    FNOL_UPDATE_ID_FLUX,
    FNOL_UPDATE_EXECUTION_CODE_MUT,
    FNOL_MAVALUE_REPORT_COMPONENT_MUT,
    FNOL_DAMAGES_CONFIRMED_MUT,
    FNOL_NO_DAMAGES,
    FNOL_IS_WLD_FLOW
} from '@/store/types'

export default {
    [FNOL_UPDATE_ID_FLUX](state, payload) {
        state.idFlux = payload
    },
    [FNOL_UPDATE_EXECUTION_CODE_MUT](state, payload) {
        state.executionCode = payload
    },
    [FNOL_MAVALUE_REPORT_COMPONENT_MUT](state, payload) {
        state.fnolMavalueReportComponent = payload
    },
    [FNOL_DAMAGES_CONFIRMED_MUT](state, payload) {
        state.damagesConfirmed = payload
    },

    [FNOL_NO_DAMAGES](state, payload) {
        state.noDamages = payload
    },

    [FNOL_IS_WLD_FLOW](state, payload) {
        state.isWldFlow = payload.isWld
        state.wldConnection = payload.connection || null
        state.wldWithAppointment = payload.withAppointment !== undefined ? payload.withAppointment : null
    }
}